import { forgotPasswordComponent } from './forgotPassword.component';

export const forgotPasswordStateName = 'app.forgotPassword';

export const forgotPasswordState = ($stateProvider) => {
  'ngInject';
  $stateProvider.state({
    name: forgotPasswordStateName,
    url: '/forgotPassword',
    component: forgotPasswordComponent.name,
  });
};
